//src/app/features/orders/ServiceOrderItem/index.tsx
import React from 'react';
import { ISubscribedServicesItems } from 'app/services/responseTypes';
import Tooltip from 'Components/Tooltips';
import UserBox from 'Components/UserBox';
import { USDate } from 'Components/Dates/USDate';

interface Props {
  service: ISubscribedServicesItems;
}

export default function ServiceOrderItem({ service }: Props) {
  const isPaid = service.state === 'paid';

  return (
    <div className="w-2/5 md-max:w-full rounded-3xl shadow-all grid gap-2 pb-4">
      {/* -- header: user + status -- */}
      <div className="border-b px-4 py-2 text-gray-dark text-sm border-gray-100 grid gap-2">
        {service.user && (
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2">
            {/* Left side: user info */}
            <UserBox
              user={service.user}
              size="xs"
              theme="white"
              content={
                service.details?.business?.name !== 'personal_business' &&
                service.details?.business?.name
              }
            />

            {/* Right side: status label */}
            <div className="flex flex-col items-start md:items-end gap-2">
              <div
                className={`text-xs capitalize px-2 py-1 rounded-lg w-max font-bold ${
                  isPaid ? 'text-green' : 'text-red-dark'
                }`}
              >
                {service.state.replace('_', ' ')}
              </div>
            </div>
          </div>
        )}
      </div>

      {/* line item */}
      <div className="border-b border-gray-100 px-4">
        <span className="capitalize flex gap-4 items-center text-sm text-gray-700">
          <span className="text-gray-dark">{service.product_meta.title}</span>
          <span className="ml-auto shadow rounded-md px-2 py-1">
            {service.price_meta.type}
          </span>
          <span className="text-green font-bold">
            ${service.price_meta.amount_cents / 100}
          </span>
        </span>
        {service.product_meta.description && (
          <span className="ml-2 text-sm text-gray-700">
            {service.product_meta.description}
          </span>
        )}
      </div>

      {/* total */}
      <div className="flex px-4 text-base font-bold text-gray-700 justify-between">
        Total
        <span className="text-green">
          ${service.price_meta.amount_cents / 100}
        </span>
      </div>

      {/* meta */}
      <div className="max-w-min">
        <Tooltip message="Service Item ID">
          <span className="px-4 text-xs text-gray-700 select-all">
            {service.id}
          </span>
        </Tooltip>
      </div>
      <USDate
        className="text-sm text-gray-700 px-4"
        date={service.created_at}
      />
    </div>
  );
}
